import { render, staticRenderFns } from "./PrestationsSuppliersList.vue?vue&type=template&id=ac8a6556&scoped=true"
import script from "./PrestationsSuppliersList.vue?vue&type=script&lang=js"
export * from "./PrestationsSuppliersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8a6556",
  null
  
)

export default component.exports